<template>
  <div class="coin_dealer">
    <!-- 顶部导航栏 -->
    <van-nav-bar placeholder safe-area-inset-top :title="$t('title.agent_account')" @click-left="goBack" left-arrow >
       <template #right>
        <img src="../assets/img/coin_dealer/coin_dealer_log.png" alt="" height="20vw" @click="dealerRule">
      </template>
    </van-nav-bar>
    <van-row>
      <van-col span="24" class="coin_dealer_overview">
       <!-- 绑定支付方式和等级排名 -->
        <van-col span="22" offset="1" class="info-row">
            <van-col span="12" @click="showPaymentMethod">
                <van-col span="24" class="info-label">{{ $t('column.payment_method')}}</van-col>
                <van-col span="20" class="info-content">
                <img :src="country_img" class="info-content-img" v-if="country_img"/> <van-icon name="arrow" size="14" />
                </van-col>
            </van-col>
            <van-col span="12"  @click="showRanking">
                <van-col span="24" class="info-label">{{ $t('column.coinseller_rank')}}</van-col>
                <van-col span="16" class="info-content">
                <van-image
                    v-for="(item, index) in coinselller_rank"
                    :key="index"
                    round width="20" height="20"
                    :src="item.head_image"
                    :style="{ marginLeft: index > 0 ? '-8px' : '0' }"
                />
                <van-icon name="arrow" size="14" />
                </van-col>
            </van-col>
        </van-col>
         <van-col span="22" offset="1" class="coin_dealer_bg">    
            <van-col span="14" offset="1" class="coin_dealer_bg_title">    
                <img src="../assets/img/coin10.png" alt="" height="10vw"> {{ $t('column.Coins_Trading')}}
            </van-col>
            <van-col span="8" class="coin_dealer_bg_right" @click.native="showDetails()"> {{ $t('column.details')}} </van-col>
            <van-col span="22" offset="1" class="coin_dealer_bg_coin"> {{ availableBalance }} </van-col>
            <van-col span="22" offset="1" class="coin_dealer_bg_btn">
                <van-button color="#7232dd" class="coin_dealer_bg_btn_exchange"  @click="coin_dealer_recharge_exchange(2)" plain round :icon="coin9"> {{ $t('column.exchange')}} </van-button>
                <van-button color="#ffffff" class="coin_dealer_bg_btn_top_up" @click="coin_dealer_recharge_exchange(1)" round > {{ $t('agent.recharge')}} </van-button>
            </van-col>
         </van-col>
         <van-col span="24" class="coin_dealer_transfer">
             <!--    transfer 转让      -->
            <van-col span="22" offset="1">
               <!-- <van-col span="10" class="action-content-transfer-type-name"> {{ $t('column.sales_methods')}}: </van-col>
              <van-col span="14" class="action-content-transfer-type">
                <van-tabs v-model="TransferActiveType" @click="TransferActiveTypeBtn" class="action-content-transfer-type-tabs" type="card" color="#ffffff" background="#EDF2F8" title-active-color="#1A1A1A" title-inactive-color="#5E5D65">
                  <van-tab title="User" name="User"></van-tab>
                  <van-tab title="Coinseller" name="CoinSeller"></van-tab>
                </van-tabs>
              </van-col> -->
              <van-col span="24" class="action-content-transfer-bg">
                 <van-col span="24" class="action-content-transfer-title">{{ $t('coin_dealer.transfer_to') }} <span class="action-content-transfer-title-span">*</span><span class="action-content-transfer-name" v-if="transferFrom.nick_name"><img :src="transferFrom.head_image"/> {{ transferFrom.nick_name }}</span></van-col>
                <van-col span="24" class="action-content-transfer-input">
                  <van-field v-model="transferFrom.user_id" :placeholder="$t('column.user_id')"  @input="transferFromMonitorUserId" @blur="onUserIdBlur">
                    <template #button>
                      <van-button size="small" @click="showRechargeUserRecord">
                        <img src="../assets/img/coin_dealer_user.png" alt="" class="coin_dealer_user_img"/>
                      </van-button>
                    </template>
                  </van-field>
                </van-col>
    
                <van-col span="24" class="action-content-transfer-title">
                  <img src="../assets/img/coin11.png" alt="" height="10vw" v-if="TransferActiveType == 'User'">
                  <img src="../assets/img/coin10.png" alt="" height="10vw" v-else></img>
                  {{ $t('coin_dealer.transfer_amount') }} <span class="action-content-transfer-title-span">*</span>
                </van-col>
                <van-col span="24" class="action-content-transfer-input">
                  <van-field v-model="transferFrom.coin" :placeholder="$t('column.please_enter')"  @input="transferFromMonitor"/>
                </van-col>
              </van-col>

              <van-col span="24" class="account-type-selection" v-if="transferFrom.is_coin_seller">
                <van-col span="24" class="account-type-title">{{ $t('coin_dealer.to_his_her') }} <span class="account-type-required">*</span></van-col>
                <van-col span="24" >
                  <van-row gutter="20">
                    <van-col span="12">
                      <van-col span="24" :class="TransferActiveType == 'User' ? 'account-card account-card-selected' : 'account-card account-card-unselected'" @click.native="TransferActiveType = 'User'">
                        <van-col span="24" class="account-card-title">{{ $t('coin_dealer.coins_account') }}</van-col>
                        <van-col span="24" class="account-card-tag">
                          <van-tag :color="TransferActiveType == 'User' ? '#FDE2BC' : '#FFFFFF'" :text-color="TransferActiveType == 'User' ? '#E9992D' : '#9DA0A5'" class="account-tag">{{ $t('coin_dealer.user') }}</van-tag>
                        </van-col>
                      </van-col>
                    </van-col>
                    <van-col span="12">
                      <van-col span="24" :class="TransferActiveType == 'CoinSeller' ? 'account-card account-card-selected' : 'account-card account-card-unselected'" @click.native="TransferActiveType = 'CoinSeller'">
                        <van-col span="24" class="account-card-title">{{ $t('coin_dealer.agent_account') }}</van-col>
                        <van-col span="24" class="account-card-tag">
                          <van-tag :color="TransferActiveType == 'User' ? '#FFFFFF' : '#FDE2BC'" :text-color="TransferActiveType == 'User' ? '#9DA0A5' : '#E9992D'" class="account-tag">{{ $t('coin_dealer.agent') }}</van-tag>
                        </van-col>
                      </van-col>
                    </van-col>
                  </van-row>
                </van-col>
                <van-col span="24" class="account-type-hint">{{ $t('coin_dealer.coins_account_hint') }}</van-col>
              </van-col>

              <van-col span="24" class="action-content-transfer-img">  
                    <van-swipe class="my-swipe" :autoplay="3000">
                       <van-swipe-item v-for="(item, index) in index_image" :key="index" @click="jump_url(item)">
                         <img :src="item.image" alt="" />
                      </van-swipe-item>
                     
                    </van-swipe>
                </van-col>
               
              <van-col span="22" offset="1" class="action-content-transfer-botton">
                <van-button color="#E4BEFF" block round v-if="!this.transferFrom.coin || !transferFrom.nick_name">{{ $t('column.Transfer')}}</van-button>
                 <van-button color="#A529FF" block round @click="TransferBtn" v-else>{{ $t('column.Transfer')}}</van-button>
              </van-col>
            </van-col>
         </van-col>
      </van-col>
       
      <van-dialog v-model="payment_method_show" show-cancel-button :close-on-click-overlay="false">
        <van-col span="24" class="payment_method_show_title"> {{ $t('column.please_finish_first')}}  </van-col>
        <van-col span="20" offset="2" class="payment_method_show_add" @click.native="CurrencyTypeShowBtn">
          <van-icon name="plus" color="#FF61F5" size="18px" /> {{ $t('column.add_payment_method') }}
        </van-col>
      </van-dialog>
      <van-popup v-model="CurrencyTypeShow" position="bottom"  round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="jump_href(item.currency_type_id)">
            <van-col span="12" class="currency_type_list_name"> <img :src="item.country_img"/> {{ item.country_name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-dialog v-model="dealer_level_show" show-cancel-button :close-on-click-overlay="true">
        <van-col span="24" class="dealer_level_show_img">
          <img src="../assets/img/coin_dealer/dealer_level_title.png"/>
        </van-col>
        <van-col span="24" class="dealer_level_show_title"> {{ $t('column.first_level_up')}} </van-col>
        <van-col span="20" offset="2" class="dealer_level_show_center"> {{ $t('column.level_up_and_unlock')}} </van-col>
        <van-col span="18" offset="3" class="dealer_level_show_btn">
          <van-button color="#FF61F5" block @click="dealerRule">{{ $t('column.level_up')}}</van-button>
        </van-col>
      </van-dialog>

      <!-- 转账确认弹框 -->
      <van-dialog v-model="transfer_confirm_show" :show-cancel-button="false" :show-confirm-button="false" :close-on-click-overlay="false" class="transfer-confirm-dialog">
        <van-col span="24" class="transfer-confirm-content">
          <!-- 用户信息卡片 -->
          <van-col span="22" offset="1" class="transfer-user-card">
            <van-col span="6" class="transfer-user-avatar">
              <img :src="transferFrom.head_image" alt="" class="transfer-avatar-img"/>
            </van-col>
            <van-col span="18" class="transfer-user-info">
              <van-col span="24" class="transfer-nickname">{{ transferFrom.nick_name }} <img :src="transferFrom.country_img" class="transfer-country-flag" v-if="transferFrom.country_img"/></van-col>
              <van-col span="24" class="transfer-user-id">ID:{{ transferFrom.user_id }}</van-col>
              <van-col span="24" class="transfer-account-type">
                <span>{{ $t('coin_dealer.coins_account') }}</span>
                <van-tag color="#FDE2BC" text-color="#E9992D" class="transfer-type-tag">{{ TransferActiveType }}</van-tag>
              </van-col>
            </van-col>
          </van-col>

          <!-- 金币数量 -->
          <van-col span="24" class="transfer-coin-amount">
            <img src="../assets/img/coin11.png" alt="" class="transfer-coin-icon" v-if="TransferActiveType == 'User'"/>
            <img src="../assets/img/coin10.png" alt="" class="transfer-coin-icon" v-else/>
            <span class="transfer-coin-value">{{ formatNumber(transferFrom.coin) }}</span>
          </van-col>

          <!-- 确认提示文本 -->
          <van-col span="20" offset="2" class="transfer-confirm-text" v-if="transferFrom.is_first_send">
            {{ $t('coin_dealer.please_input_user_id_confirm') }}<span class="transfer-confirm-highlight">{{ transferFrom.user_id }}</span> {{ $t('coin_dealer.to_confirm_transaction') }}
          </van-col>

          <!-- 用户ID输入框 -->
          <van-col span="22" offset="1" class="transfer-input-wrapper" v-if="transferFrom.is_first_send">
            <van-field v-model="confirmUserId" :placeholder="$t('coin_dealer.please_enter_user_id')" class="transfer-input-wrapper-input"/>
          </van-col>

          <!-- 按钮组 -->
          <van-col span="22" offset="1" class="transfer-buttons">
            <van-button color="#F3F4F6" block round class="transfer-cancel-btn" @click="transfer_confirm_show = false">{{ $t('coin_dealer.cancel') }}</van-button>
            <van-button color="#A529FF" block round class="transfer-confirm-btn" @click="confirmTransfer">{{ $t('coin_dealer.confirm') }}</van-button>
          </van-col>
        </van-col>
      </van-dialog>

      <!-- 最近交易记录弹框 -->
      <van-popup v-model="recharge_user_record_show" position="bottom" round :style="{ height: '80%' }">
        <van-col span="24" class="recharge-record-header">
          <van-col span="17" offset="3" class="recharge-record-title">{{ $t('coin_dealer.recent_transactions') }}</van-col>
          <van-col span="4" class="recharge-record-close" @click="recharge_user_record_show = false">
            <van-icon name="cross" size="20" />
          </van-col>
        </van-col>
        
        <!-- 搜索框 -->
        <van-col span="24" class="recharge-record-search">
          <van-search
            v-model="searchKeyword"
            show-action
            shape="round"
            :placeholder="$t('coin_dealer.search_placeholder')"
            @search="onSearch"
            @cancel="onCancel"
            clearable
          >
          <template #action>
            <div @click="onSearch">{{ $t('coin_dealer.search') }}</div>
          </template>
        </van-search>
        </van-col>
        
        <!-- 交易记录列表 -->
        <van-col span="24" class="recharge-record-list">
          <van-col span="22" offset="1" class="recharge-record-item" v-for="(item, index) in recharge_user_record" :key="index" @click="selectRechargeUser(item)">
            <van-col span="5" class="recharge-record-avatar">
              <img :src="item.head_image" alt="" class="recharge-record-avatar-img"/>
            </van-col>
            <van-col span="11" class="recharge-record-info">
              <van-col span="24" class="recharge-record-nickname">{{ item.nick_name }} <img :src="item.country_img" class="recharge-record-country" /></van-col>
              <van-col span="24" class="recharge-record-id">ID:{{ item.user_id }}</van-col>
            </van-col>
            <van-col span="8" class="recharge-record-time">{{ item.update_date }} <van-icon name="arrow" size="16"/></van-col>
          </van-col>
          
          <van-empty v-if="recharge_user_record.length === 0" :description="searchKeyword ? $t('coin_dealer.no_matching_records') : $t('coin_dealer.no_transaction_records')" />
        </van-col>
      </van-popup>

    </van-row>

  </div>
</template>

<script>
import '@/assets/css/style.css'
import Toast from 'vant/lib/toast'
import axios from "axios";
import {Dialog} from "vant";
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  name: 'CoinDealer',
  data() {
    return {
      coin9: require('../assets/img/coin9.png'),
      CurrencyTypeShow: false,
      dealer_level_show: false,
      transferFrom:{
        user_id: undefined,
        coin: undefined,
        ticket: undefined,
        nick_name: undefined,
        head_image: undefined,
        is_coin_seller: undefined,
        is_first_send: undefined
      },
      recharge_user_record_show: false, // 控制最近交易记录弹框显示
      seller_currency_name: undefined,
      totalBalance: '0',
      availableBalance: '0',
      securityDeposit: '0',
      userInfo: {},
      coinselller_rank: [],
      currency_type: [],
      country_img: undefined,
      payment_method_show: false,
      TransferActiveType: 'User',
      buyer_type_list: [
        {id:0, name: 'ALL'},
        {id:1, name: 'User'},
        {id:2, name: 'Reseller'}
      ],
      loading: false,
      finished: false,
      page: 1,
      index_image: [],
      recharge_user_record: [],
      searchKeyword: '', // 搜索关键词
      transfer_confirm_show: false, // 转账确认弹框
      confirmUserId: '' // 确认输入的用户ID
    }
  },
  created() {
    this.searchKeyword = ''
    this.get_list()
    this.get_recent_recharge_user_record()
    
  },
  methods: {
    dealerRule() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_dealer_level', query: { uid: uid, token: token } });
    },
    jump_url(item) {
      if(item.url){
        // 拦截内部链接
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.jump_internal_link.postMessage(item.url)
        } else {
          // Android传值方法传值方式-跳转内部链接
          window.AndroidJs.jump_internal_link(item.url)
        }
      }
    },
    jump_href(currency_type_id) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_payment_method_select', query: { uid: uid, token: token, currency_type_id: currency_type_id } });
    },
    coin_dealer_recharge_exchange(type) {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        if(type == 2){
          this.$router.push({ path: '/coin_dealer_exchange', query: { uid: uid, token: token } });
        }else{
          this.$router.push({ path: '/coin_dealer_recharge_exchange_v2', query: { uid: uid, token: token, type: type } });
        }
    },
    formatNumber(num) {
      // 千分位格式化
      if (!num && num !== 0) return '0';
      return Number(num).toLocaleString();
    },
    TransferActiveTypeBtn() {
      this.transferFrom.user_id = undefined
      this.transferFrom.coin = undefined
      this.transferFrom.ticket = undefined
      this.transferFrom.nick_name = undefined
      this.transferFrom.head_image = undefined
      this.transferFrom.is_coin_seller = undefined
      this.transferFrom.is_first_send = undefined

      if(this.TransferActiveType == 'User'){
        if(this.userInfo.transfer_user_active != 1){
          // 没有权限
          this.dealer_level_show = true
        }
      } else{
        if(this.userInfo.transfer_seller_active != 1){
          // 没有权限
          this.dealer_level_show = true
        }
      }
    },
    checkUserId() {
      if(!this.transferFrom.user_id){
        Toast(this.$t('other.Please_input_user_id'))
        return
      }
      // 检测用户是否存在
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=check_user_or_coin_seller",{
        params:{uid: uid, token: token, to_user_id: this.transferFrom.user_id, transfer_type: this.TransferActiveType }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if (res.data.status===1){
          this.transferFrom.nick_name = res.data.data.nick_name
          this.transferFrom.head_image = res.data.data.head_image
          this.transferFrom.is_coin_seller = res.data.data.is_coin_seller
          this.transferFrom.is_first_send = res.data.data.is_first_send
        }else{
          Toast(res.data.error)
        }
      })
    },
    transferFromMonitor(value) {
      this.transferFrom.coin = value.replace(/[^\d]/g, '');
      if (this.TransferActiveType === 'User'){
        // 转让给用户
        this.transferFrom.ticket = Math.floor(this.transferFrom.coin * this.userInfo.seller_user_rate)
      } else {
        // 转让给机构
        this.transferFrom.ticket = Math.floor(this.transferFrom.coin * this.userInfo.seller_merchant_rate)
      }
    },
    transferFromMonitorUserId(value){
      this.transferFrom.user_id = value.replace(/[^\d]/g, '');
    },
    onUserIdBlur() {
      // 输入框失焦时，如果有输入值则自动检查
      if (this.transferFrom.user_id && this.transferFrom.user_id.trim()) {
        this.checkUserId()
      }
    },
    CurrencyTypeShowBtn() {
      this.payment_method_show = false
      this.CurrencyTypeShow = true
    },
    get_list(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_coin_dealer_info",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.userInfo = res.data.data.userInfo
          this.currency_type = res.data.data.currency_type
          this.coinselller_rank = res.data.data.coinselller_rank
          this.country_img = res.data.data.country_img
          this.payment_method_show =  !this.country_img
          this.availableBalance = res.data.data.userInfo.coin
          this.securityDeposit = res.data.data.userInfo.deposit_coin
          this.totalBalance = parseInt(this.availableBalance) + parseInt(this.securityDeposit)

          this.seller_recharge_multiple = res.data.data.seller_recharge_multiple
          this.seller_currency_name = res.data.data.seller_currency_name
          this.index_image = res.data.data.index_image
          
        }else{
          Toast(res.data.error)
        }
      })
    },
    get_recent_recharge_user_record(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_recent_recharge_user_record",{
        params:{uid: uid, token: token, keyword: this.searchKeyword}
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.recharge_user_record = res.data.data.list
        }else{
          Toast(res.data.error)
        }
      })
    },
    showRechargeUserRecord() {
      // 打开最近交易记录弹框
      this.recharge_user_record_show = true
      // 打开弹框时加载数据
      this.get_recent_recharge_user_record()
    },
    selectRechargeUser(item) {
      // 选择交易记录中的用户，填充到输入框
      this.transferFrom.user_id = item.user_id
      this.transferFrom.nick_name = item.nick_name
      this.transferFrom.head_image = item.head_image
      this.transferFrom.is_first_send = item.is_first_send
      this.transferFrom.is_coin_seller = item.is_coin_seller
      this.recharge_user_record_show = false
    },
    onSearch() {
      // 搜索时重新请求接口
      this.get_recent_recharge_user_record()
    },
    onCancel() {
      // 取消搜索，清空搜索关键词并重新加载全部数据
      this.searchKeyword = ''
      this.get_recent_recharge_user_record()
    },
    goBack() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    showPaymentMethod() {
      if (this.country_img) {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({ path: '/coin_seller_payment_method', query: { uid: uid, token: token } });
      } else {
        this.payment_method_show = true
      }
    },
    showRanking() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_ranking', query: { uid: uid, token: token } })
    },
    showDetails() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_details_v2', query: { uid: uid, token: token } })
    },
    TransferBtn(){
      if (this.userInfo.transfer_user_active == 0 && this.userInfo.transfer_seller_active == 0){
        // 没有权限
        this.dealer_level_show = true
        return false
      }
      // 显示转账确认弹框
      this.transfer_confirm_show = true
      this.confirmUserId = ''
    },
    confirmTransfer(){
      // 验证输入的用户ID是否正确
      if (this.transferFrom.is_first_send) {
        if (this.confirmUserId !== this.transferFrom.user_id){
          Toast(this.$t('coin_dealer.user_id_not_match'))
          return
        }
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=coin_seller_transfer_operation",{
        params:{uid: uid, token: token, to_user_id: this.transferFrom.user_id, transfer_type: this.TransferActiveType, coin: this.transferFrom.coin,no_deposit_coin: 1}
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        this.transfer_confirm_show = false
        if(res.data.status !==1){
          Toast(res.data.error)
        }else{
          this.TransferActiveTypeBtn()
          Toast({
            message: res.data.error,
            duration: 2000, // 持续2秒
            onClose: () => {
              // 这里写Toast关闭后要执行的方法
                this.searchKeyword = ''
                this.get_list()
                this.get_recent_recharge_user_record()
            }
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.account-type-selection {
  padding: 16px;
  background: #FFFFFF;
  border-radius: 12px;
  margin: 16px 0;
}

.account-type-title {
  font-size: 16px;
  font-weight: 500;
  color: #1A1A1A;
  margin-bottom: 12px;
}

.account-type-required {
  color: #FF4D4F;
}

.account-type-cards {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
}

.account-card {
  padding: 16px;
  border-radius: 12px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.account-card-selected {
  background: #FFF9F0;
  border-color: #FFB84D;
}

.account-card-unselected {
  background: #F3F4F6;
  border-color: transparent;
}

.account-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1A1A1A;
  margin-bottom: 8px;
}

.account-card-title-disabled {
  color: #9CA3AF;
}

.account-card-tag {
  display: inline-block;
  width: fit-content;
}

.account-tag {
  padding: 2px 12px;
  border-radius: 16px;
  font-size: 0.8rem;
}

.account-type-hint {
  font-size: 14px;
  color: #9CA3AF;
  margin-top: 8px;
}

/* 最近交易记录弹框样式 */
.recharge-record-header {
  display: flex;
  align-items: center;
  padding: 16px;
}

.recharge-record-title {
  font-size: 18px;
  font-weight: 600;
  color: #1A1A1A;
  text-align: center;
}

.recharge-record-close {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}

.recharge-record-search {
  padding: 12px 16px;
  background: #FFFFFF;
}

.recharge-record-list {
  padding: 8px 0;
  max-height: calc(80vh - 120px);
  overflow-y: auto;
}

.recharge-record-item {
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #F3F4F6;
  cursor: pointer;
  transition: background-color 0.2s;
}

.recharge-record-item:hover {
  background-color: #F9FAFB;
}

.recharge-record-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.recharge-record-avatar-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.recharge-record-info {
  padding-left: 5px;
}

.recharge-record-nickname {
  font-weight: 500;
  color: #1A1A1A;
  margin-bottom: 2vw;
  display: flex;
  align-items: center;
}

.recharge-record-country {
  width: 16px;
  height: 12px;
  margin-left: 6px;
  object-fit: cover;
}

.recharge-record-id {
  font-size: 0.7rem;
  color: #6A6A6A;
  background: #EBEAF0;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  width: fit-content;
}

.recharge-record-time {
  font-size: 13px;
  color: #6B7280;
  text-align: right;
  .van-icon{vertical-align: middle;}
}

/* 转账确认弹框样式 */
.transfer-confirm-dialog >>> .van-dialog__content {
  padding: 24px 5px;
}

.transfer-confirm-content {
  padding: 3vw 0 7vw;
}

.transfer-user-card {
  background: #F3F4F6;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.transfer-user-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.transfer-avatar-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.transfer-user-info {
  padding-left: 12px;
}

.transfer-nickname {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A1A;
  display: flex;
  align-items: center;
}

.transfer-country-flag {
  width: 16px;
  height: 12px;
  margin-left: 6px;
  object-fit: cover;
}

.transfer-user-id {
  font-size: 13px;
  color: #6B7280;
}

.transfer-account-type {
  font-size: 14px;
  color: #1A1A1A;
  display: flex;
  align-items: center;
}

.transfer-type-tag {
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 10px;
}

.transfer-coin-amount {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.transfer-coin-icon {
  height: 5vw;
  margin-right: 8px;
  vertical-align: middle;
}

.transfer-coin-value {
  font-size: 1.8rem;
  font-weight: 600;
  color: #F59E0B;
}

.transfer-confirm-text {
  text-align: center;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  margin-bottom: 20px;
}

.transfer-confirm-highlight {
  color: #EF4444;
  font-weight: 600;
}

.transfer-input-wrapper {
  margin-bottom: 24px;
}
.transfer-input-wrapper-input{
  background: #F7F7F7;
  border-radius: 3vw;
}
.transfer-input-wrapper >>> .van-field__control {
  text-align: center;
  font-size: 16px;
}

.transfer-buttons {
  margin-top: 3vw;
  display: flex;
  gap: 12px;
}

.transfer-cancel-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  color: #919297 !important;
}

.transfer-confirm-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/coin_dealer_v2.vue